<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="encashment"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :date="date"
      :sort="sort"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Инкассации</h1>
        <btn-filters
          :data="data"
          endpoint="encashment"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @load-more="$refs.data.loadMore"
        @sort-change="sortChange"
      >
        <table-column-date/>
        <table-column-serial-number prop="machine.serial_number" sortable="params.serial_number" machine-prop="machine"/>
        <el-table-column prop="machine.address" label="Адрес" :show-overflow-tooltip="true" min-width="220"/>
        <table-column-number align="right" prop="params.sales_count" sortable="custom" label="Количество продаж" currencySymbol="шт." tableColumnType="number"/>
        <table-column-number align="right" prop="params.sales_sum" sortable="custom" label="Сумма продаж" currencySymbol="₽" tableColumnType="number"/>
        <table-column-number align="right" prop="params.delivery" sortable="custom" label="Загружено сдачи" currencySymbol="₽" tableColumnType="number"/>
        <table-column-number align="right" prop="params.inserted_coins_summary" sortable="custom" label="Монет" currencySymbol="₽" tableColumnType="number"/>
        <table-column-number align="right" prop="params.inserted_banknotes_summary" sortable="custom" label="Купюр" currencySymbol="₽" tableColumnType="number"/>
        <table-column-number align="right" prop="params.inserted_tokens_summary" sortable="custom" label="Жетонов" currencySymbol="₽" tableColumnType="number"/>
        <table-column-number align="right" prop="params.inserted_money_summary" sortable="custom" label="Всего" currencySymbol="₽" tableColumnType="number"/>
        <el-table-column align="center" prop="params.bag_id" sortable="keyword" label="Номер мешка"/>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import withTooltip from '../../with-tooltip'

  export default {
    metaInfo: {title: 'Инкассации'},
    data () {
      return {
        filtersValue: null,
        data: {},
        loading: false,
        hasMore: true,
        date: {
          min: null,
          max: null,
        },
        sort: null,
      }
    },
    methods: {
      withTooltip,
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const sortable = sort.column.sortable

          // set prop name
          let prop = (sortable === 'keyword') ? sort.prop + '.keyword' : (sortable === 'custom' ? sort.prop : sortable)
          // add event name
          prop = prop.replace(/params/gi, 'params_encashment')

          this.sort = `${prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/encashment.vue